// src/core/rutas-publicas.js — whitelist de rutas accesibles para visitante anon.
//
// FASE 3.17 · Bloque D. El gate de auth (F1.2, en main.js → renderApp) cortaba
// a renderLogin sin importar la ruta cuando no hay sesión. Para que el link
// viral /t/AUDIO_ID y la Tribuna Pública (entera y sus sub-vistas) funcionen
// sin login, las rutas listadas acá bypassean el gate: renderApp deja pasar al
// router, y las vistas ya saben distinguir visitante (`currentUser` null) desde
// F1.3.d2.
//
// Extraído de main.js (sigue siendo el mismo predicado) para poder testear el
// gate real del navegador sin bootstrapear main.js entero.
//
// Tribuna Pública es contenido público: arengas (inline en /tribuna), cábalas
// (/tribuna-cabalas/) y promesas (/tribuna-promesas/) se ven sin login, con el
// mismo nivel de acceso. Reaccionar adentro sigue pidiendo registro.

export const RUTAS_PUBLICAS_PREFIX = ['/tribuna/', '/tribuna-cabalas/', '/tribuna-promesas/', '/t/'];

// /dev-sandbox: página de QA del dueño (H4), accesible sin sesión.
// /tribuna (entera, sin código): el link público compartible en modo visitante.
export const RUTAS_PUBLICAS_EXACT = ['/dev-sandbox', '/tribuna'];

export const esRutaPublica = (hash) =>
  RUTAS_PUBLICAS_PREFIX.some((p) => hash.startsWith(p)) ||
  RUTAS_PUBLICAS_EXACT.includes(hash);
